import {Dialog,DialogTitle,DialogContent,DialogActions,Button,Typography,IconButton,Chip,Box} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import EmailViewer from "../../common2/EmailViewer";
import SmallAttachmentPreview from "../../EmailTemplates/SmallAttachmentPreview";
function SSPEmailViewer({ data,onClose}: any) {
  const mailStyle = {
  minWidth: '50px',
  display: 'inline-block',
  marginBottom: '10px'
};
  const [open, setOpen] = useState(true);

  const subject = data?.title || data?.subject;
  const from = data?.from;
  const to = data?.to; 
  const cc = data?.cc;
  const bcc = data?.bcc;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between",color:"#273A6B" }}>
        {subject}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {from && <Typography><span style={mailStyle}>From </span>: 
        <Chip label={from} size="small" variant="filled" sx={{ml:'10px'}}/></Typography>}
        
        {to && <Typography><span style={mailStyle}>TO </span> : 
        {to?.split(';').map((chip:any,index:any) => (
        <Chip label={chip} size="small" variant="filled" sx={{mx:'10px'}}/> 
        ))}
        </Typography>}

        {cc && <Typography><span style={mailStyle}>CC </span> : 
        {cc?.split(';').map((chip:any,index:any) => (
        <Chip label={chip} size="small" variant="filled" sx={{mx:'10px'}}/> 
        ))}
        </Typography>}

        {bcc && <Typography><span style={mailStyle}>BCC </span> :
        {bcc?.split(';').map((chip:any,index:any) => (
        <Chip label={chip} size="small" variant="filled" sx={{mx:'10px'}}/> 
        ))}
        </Typography>}
         <Box>
            <div className="pb-1">
              <SmallAttachmentPreview
                attachments={data?.ticketLogAttachments}
              />
            </div>
                  </Box>
        <Box className="text-box-like-border" sx={{ mt: 2,mx:2 }}>
          <EmailViewer body={data?.body || " "} height={400} />
      </Box>
      </DialogContent>
      
      

      <DialogActions>
        <Button variant="outlined" onClick={onClose}  endIcon={<CloseIcon sx={{ width: "20px" }} />} >
          Close
        </Button>
      </DialogActions>

    </Dialog>
  );
}
export default SSPEmailViewer